import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco'; // Add this import
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MyDataService } from 'src/app/services/data/data.service';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';
import { TicketsService } from 'src/app/services/tickets/tickets.service';

@Component({
  selector: 'app-citas',
  templateUrl: './citas.component.html',
  styleUrls: ['./citas.component.scss'],
})
export class CitasComponent implements OnInit {
  private destroyed$ = new Subject<void>();

  tickets: any = [];

  citas: any = [];

  citasExample = [
    {
      ID: 1,
      fk_tracking: 111111,
    },
  ];

  user: any = null;

  project: any = null;

  constructor(
    private router: Router,
    private ticketsSvc: TicketsService,
    private dataSvc: MyDataService,
    private snackBarService: SnackBarService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    const proyectoPlatform = this.dataSvc.getFkEntityPlatform();
    const user = this.dataSvc.getUserPlatform();
    if (user) {
      this.user = user;
      if (this.user && this.project) {
        this.getCitasTicketsCliente();
      }
    } else {
      this.dataSvc.getUserObservable().subscribe((value) => {
        this.user = value;
        if (this.user && this.project) {
          this.getCitasTicketsCliente();
        }
      });
    }
    if (proyectoPlatform) {
      this.project = proyectoPlatform;
      if (this.user && this.project) {
        this.getCitasTicketsCliente();
      }
    } else {
      this.dataSvc.getFkEntityPlatformObservable().subscribe((value) => {
        this.project = value;
        if (this.user && this.project) {
          this.getCitasTicketsCliente();
        }
      });
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje);
  }

  formatFecha(fechaOriginal: string) {
    if (fechaOriginal) {
      const fechaFormateada = moment(fechaOriginal).format('DD-MM-YYYY HH:mm');
      return fechaFormateada;
    } else {
      return '';
    }
  }

  getCitasTicketsCliente() {
    this.ticketsSvc
      .getTicketsCliente(this.project, this?.user?.cliente.ID)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.tickets = response.ticketsAbiertos.concat(
            response.ticketsCerrados
          );
          const ticketsIDs = this.tickets.map((ticket: any) => ticket.ID);
          this.ticketsSvc
            .getCitasTicketsCliente(ticketsIDs)
            .pipe(takeUntil(this.destroyed$))
            .subscribe({
              next: (response2: any) => {
                console.log(response2);
                this.citas = response2;
              },
              error: (e) => {
                console.log(e);
                this.showSnackBarError(
                  this.translocoService.translate(
                    'appointments.error.loadTickets'
                  )
                );
              },
            });
        },
        error: (e) => {
          console.log(e);
          this.showSnackBarError(
            this.translocoService.translate('appointments.error.loadTickets')
          );
        },
      });
  }
}
